import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {useRef} from 'react';
import {useArticleFileUpload} from '../../../../../articles/hooks/use-article-file-upload.hook';
import {environment} from '../../../../../../environments/environment';
import {
    INSERT_UPLOADING_IMAGE_COMMAND,
    REPLACE_WITH_UPLOADED_IMAGE_COMMAND
} from "@common/components/forms/rich-text-form-field/plugins/image-upload-plugin";

function makeFileId() {
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
        return `temp_${crypto.randomUUID()}`;
    }
    return `temp_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

function fileDedupKey(file: File) {
    return `${file.name}:${file.size}:${file.lastModified}`;
}

function readFileAsDataURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => reject(reader.error);
        reader.onload = () => resolve(String(reader.result));
        reader.readAsDataURL(file);
    });
}

export const useImageUpload = () => {
    const [editor] = useLexicalComposerContext();
    const {uploadFile} = useArticleFileUpload();

    const uploadingRef = useRef<Set<string>>(new Set());

    const handleFileUpload = async (file: File) => {
        const dedup = fileDedupKey(file);
        if (uploadingRef.current.has(dedup)) return;

        uploadingRef.current.add(dedup);
        const fileId = makeFileId();

        try {
            const tempSrc = await readFileAsDataURL(file);
            editor.dispatchCommand(INSERT_UPLOADING_IMAGE_COMMAND, {
                src: tempSrc,
                altText: file.name,
                fileId,
                originalName: file.name,
            });

            const uploaded = await uploadFile(file);

            editor.dispatchCommand(REPLACE_WITH_UPLOADED_IMAGE_COMMAND, {
                tempFileId: fileId,
                fileId: uploaded.id,
                newSrc: environment.backendUrl.replace("/api","/files")+ uploaded.url.replaceAll("\\","/"),
            });
        } catch (e) {
            console.error('Błąd podczas uploadu obrazu:', e);
        } finally {
            uploadingRef.current.delete(dedup);
        }
    };

    return {handleFileUpload};
};
